import { request, withQuery } from './client';
import type { CustomerBonus, CustomerCard, CustomerCreate, CustomerListResponse, CustomerPatch } from '@kassa/shared';

export const customersApi = {
  customers: (p: { q?: string; credit?: string; page?: number; limit?: number; sort?: string }) =>
    request<CustomerListResponse>('GET', withQuery('/api/customers', { ...p })),
  customerCard: (id: string) => request<CustomerCard>('GET', `/api/customers/${encodeURIComponent(id)}`),
  customerCreate: (body: CustomerCreate) => request<{ id: string }>('POST', '/api/customers', body),
  customerPatch: (id: string, body: CustomerPatch) =>
    request<{ id: string }>('PATCH', `/api/customers/${encodeURIComponent(id)}`, body),
  // Bonus (KT-96)
  customerBonus: (id: string) => request<CustomerBonus>('GET', `/api/customers/${encodeURIComponent(id)}/bonus`),
  customerBonusAdjust: (id: string, points: number, note: string) =>
    request<CustomerBonus>('POST', `/api/customers/${encodeURIComponent(id)}/bonus`, { points, note }),
};
